import { useState } from "react";

import * as Mui from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import useModalZIndex from "@hooks/useModalZIndex";
import { Button } from "@fragments";

import "./styles.scss";

export default function ConfirmModal({ }) {
  const [modal, setModal] = useState({
    open: false,
    config: {
      className: "",
      title: "",
      headline: "",
      subtitle: "",
      buttons: [
        {
          text: "Confirmar",
          onClick: () => { },
          variant: "contained",
          className: "",
          color: "error",
        },
        {
          text: "Cancelar",
          variant: "text",
        },
      ],
    },
  });

  const [loading, setLoading] = useState(false);

  function handleClose() {
    setModal({
      open: false,
      config: {},
    });
  }

  function handleOpen(config) {
    setModal({
      open: true,
      config,
    });
  }

  async function handleClick(callback) {
    setLoading(true);
    try {
      const result = await callback();
      setLoading(false);
      handleClose();
      return result;
    } catch (e) {
      setLoading(false);
      handleClose();
      return e;
    }
  }

  window.openConfirm = handleOpen;

  const { config } = modal;
  const { zIndex, isTop } = useModalZIndex(modal.open);

  return (
    <Mui.Modal
      open={modal.open}
      onClose={handleClose}
      sx={{ "--modal-z": zIndex }}
      disableEnforceFocus={!isTop}
    >
      <div className={"modal-confirm  " + modal.className}>
        <div className="confirm-modal-header px-2 py-1 ">
          <Mui.Typography component="h4">{config.title}</Mui.Typography>
          <Mui.IconButton size="small" onClick={handleClose}>
            <CloseIcon />
          </Mui.IconButton>
        </div>

        <Mui.Divider />

        <div className="px-3 py-2">
          <Mui.Typography variant="h6" component="h2" className="mb-1">
            {config.headline}
          </Mui.Typography>
          <h4 component="h4" className="bold">{config.subtitle}</h4>

          <div className="mt-2 mb-1 confirm-buttons-footer">
            {config.buttons?.map((btn, i) => (
              <Button
                fullWidth
                loading={loading}
                key={i}
                variant={btn.variant || "text"}
                onClick={() => handleClick(btn.onClick || handleClose)}
                className={"modal-confirm-btn mt-1 " + btn.className}
                color={
                  btn.color ||
                  (btn.variant !== "contained" ? "secondary" : "primary")
                }
              >
                {btn.text}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </Mui.Modal>
  );
}
